$(function() {
    $.appendQuerystring = function(qsObj, replace) {
        if (!window.history || !window.history.pushState) {
            return false;
        }

        replace = replace || false;

        var queryObj = parseQueryString(window.location.search);
        var targetQsObj = (replace) ? qsObj : $.extend(queryObj, qsObj);
        var newQs = stringifyQuery(targetQsObj);

        window.history.pushState(null, '', '?' + newQs);
    }

    function stringifyQuery(query) {
        var pairs = [];

        for(var key in query) {
            var tmp = key;

            if (query[key]) {
                tmp += '=';
                tmp += window.encodeURIComponent(query[key]);
                tmp = tmp.replace('%20', '+');
            }

            pairs.push(tmp);
        }

        return pairs.join('&');
    }

    function parseQueryString(qs) {
        if (qs === '') {
            return {};
        }

        if (qs[0] === '?') {
            qs = qs.slice(1, qs.length);
        }

        var pairs = qs.split('&');
        var queryObj = {};

        for(var i = 0; i < pairs.length; i++) {
            var tmp = pairs[i].split('=');
            if (tmp.length === 2) {
                if (tmp[1] === 'true') {
                    queryObj[tmp[0]] = true;
                } else if (tmp[1] === 'false') {
                    queryObj[tmp[0]] = false;
                } else {
                    tmp[1] = tmp[1].replace('+', ' ');
                    queryObj[tmp[0]] = window.decodeURIComponent(tmp[1]);
                }
            }
            if (tmp.length === 1) {
                queryObj[tmp[0]] = undefined;
            }
        }

        return queryObj;
    }

    $.parseQueryString = parseQueryString;
});
